<template>
    <div >
      <v-row>
        <v-col sm='12'>
          <div id="notas">
            <div v-for="(nota, index) in listaNotas" :key="nota.msol_id" class="listanotas">
                <textarea @blur="updelNote(index,nota.msol_id)" v-model="nota.msol_texto"></textarea>
                <span class="user">{{nota.msol_user_id}}</span>
            </div>
            <div class="addnote">
              <textarea @blur="addNote" v-model="msol_texto_add"></textarea>
            </div>  
          </div>
        </v-col>
      </v-row>
    </div>
</template>
<script>
import { NotasApiService } from '@/api/NotasApiService'

const notasLinkApiService = new NotasApiService()

export default {
  data () {
    return {
        nota: {
            msol_texto: '',
            msol_fecha: '',
            msol_user_id: '',
            msol_workspace_id : 0,
            msol_id: ''
        },
        msol_texto_add: '',
        listaNotas: [],
        opuid: this.$store.getters.getOpuid,
        user: this.$store.getters.getUserName,
        wsid: this.$store.getters.getWsid
    }
  },
  methods: {
    init(){
      this.listaNotas.length = 0
      this.getAllNotas()
    },
    cambioTitulo () {
      this.$store.state.tituloIcono = `<i class="icon-paste"></i>`
      this.$store.state.titulo = "Notas"
    },
    addNote() {
      if (this.msol_texto_add != ''){
        this.nota.msol_fecha = new Date(Date.now())
        this.nota.msol_user_id = this.user
        this.nota.msol_workspace_id = this.wsid
        this.nota.msol_texto = this.msol_texto_add;
        this.msol_texto_add = ''

        notasLinkApiService.createNota(this.nota)
          .then(data => {
            data.msol_fecha = new Date(data.msol_fecha).toLocaleString()
            this.nota.msol_texto= ''
            // this.listaNotas.length = 0
            // this.getAllNotas()
            this.listaNotas.push(data)
          })
          .catch(error => {
            console.log('Notas - createNota', error, 'ERROR')
          })
        }
    },
    removeNote(index, notaId) {
      let notaAux = {
        msol_id:  notaId
      }
      notasLinkApiService.deleteNota(notaAux)
        .then(data => {
          if (data.deleted)
            this.$delete(this.listaNotas, index)
        })
        .catch(error => {
          console.log('Notas - deleteNota', error, 'ERROR')
        })
        
    },
    stripHtml (html)  {
      var tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    },  
    getAllNotas() {     
      notasLinkApiService.getAllNotas(this.opuid)
        .then(data => {
          console.log('Weblink - getAllNotas', data.length, 'OK')
          if (data) {
            data.forEach(element => {
              this.listaNotas.push({
                  msol_texto: this.stripHtml(element.msol_texto),
                  msol_fecha: element.msol_fecha,
                  msol_user_id: element.msol_user_id,
                  msol_id: element.msol_id
              })
            });
          } else {
            this.listaNotas = []
          }
        })
        .catch(error => {
          this.listaNotas = []
          console.log('Weblink - getAllNotas', error, 'ERROR')
        })
    },
    updelNote(index, notaId){
      if (this.listaNotas[index].msol_texto == ''){
        this.removeNote(index,notaId);
      }
      else{
        this.listaNotas[index].msol_fecha = new Date(Date.now());
        notasLinkApiService.updateNota(this.listaNotas[index])
          .then(data => {
            this.msol_texto_add = '';
          })
      }
    }
  },
  computed: {
    cambiotienda () {
      return [this.$store.getters.getWsid,this.$store.getters.getOpuid] ;
    }
  },
  mounted() {
    this.cambioTitulo()
    this.init();
  },
  watch: {
    listaNotas: {
      handler() {
          localStorage.setItem('listaNotas', JSON.stringify(this.listaNotas));
      },
      deep: true, 
    },
    cambiotienda (value) {
      this.wsid = value[0]
      this.opuid = value[1]
      this.init()
    }
  }
}
</script>
